/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SFMChildPositionV1Dto } from './SFMChildPositionV1Dto';
import type { SimpleNameV1Dto } from './SimpleNameV1Dto';
export type OperatingCostInvoiceLineItemV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Area designation (Flächenbezeichnung)
   */
  areaDesignation: string;
  /**
   * name of the position. (Bezeichnung lt. Abrechnung)
   */
  nameOnStatement: string;
  /**
   * flat rate (Pauschale)
   */
  isFlatRate: boolean;
  /**
   * the total amount of the line item (Gesamtbetrag)
   */
  totalAmount?: number;
  /**
   * the customer amount, a share of the totalAmount (Betrag Kunde)
   */
  customerAmount?: number;
  /**
   * The total size of the area in square meters (Gesamtfläche)
   */
  totalArea?: number;
  /**
   * The customer size of the area in square meters (Kundenfläche)
   */
  customerArea?: number;
  status: OperatingCostInvoiceLineItemV1Dto.status;
  /**
   * The unit of measurement for this line item.
   */
  unit?: OperatingCostInvoiceLineItemV1Dto.unit;
  /**
   * The unique identifier of OperatingCostInvoice
   */
  invoiceId: string;
  /**
   * Linked area (read model, id + name).
   */
  area?: SimpleNameV1Dto;
  /**
   * Linked area (read model, id + name).
   */
  sfmPosition: SFMChildPositionV1Dto;
  /**
   * Positionsnummer (for sorting)
   */
  position: number;
};
export namespace OperatingCostInvoiceLineItemV1Dto {
  export enum status {
    CLEAR = 'Clear',
    UNCLEAR = 'Unclear',
  }
  /**
   * The unit of measurement for this line item.
   */
  export enum unit {
    SQUARE_METER = 'SquareMeter',
    CUBIC_METER = 'CubicMeter',
    KILOWATT_HOURS = 'KilowattHours',
    PIECE = 'Piece',
    DEGREE_DAYS = 'DegreeDays',
    PERCENT = 'Percent',
    KILOGRAM = 'Kilogram',
    HOURS = 'Hours',
  }
}
